module.exports = __webpack_public_path__ + "img/oufu_52x81x11.prt.6c1945b8.jpg";